import { useFormContext } from 'react-hook-form';
import { Select } from '@/components/common';
import type { MotorQuoteFormData } from '../../schema';

const CURRENT_YEAR = new Date().getFullYear();
const YEAR_OPTIONS = Array.from({ length: 40 }, (_, i) => ({
  value: String(CURRENT_YEAR - i),
  label: String(CURRENT_YEAR - i),
}));

export function ManufacturingYearStep() {
  const {
    register,
    formState: { errors },
  } = useFormContext<MotorQuoteFormData>();

  return (
    <div>
      <h2 className="text-lg font-semibold text-gray-900 dark:text-white">Manufacturing Year</h2>
      <p className="text-sm text-gray-500 dark:text-gray-400 mt-1 mb-6">
        Select the vehicle&rsquo;s year of manufacture.
      </p>
      <div className="sm:max-w-xs">
        <Select
          label="Manufacturing Year"
          options={YEAR_OPTIONS}
          placeholder="Select year..."
          error={errors.manufacturing_year?.message}
          required
          {...register('manufacturing_year')}
        />
      </div>
    </div>
  );
}
